import { render } from "./SeparateTestPreviousPage.vue?vue&type=template&id=31ae6c6b&scoped=true"
import script from "./SeparateTestPreviousPage.vue?vue&type=script&lang=js"
export * from "./SeparateTestPreviousPage.vue?vue&type=script&lang=js"

import "./SeparateTestPreviousPage.vue?vue&type=style&index=0&id=31ae6c6b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ae6c6b"]])

export default __exports__